import React, { useState, useEffect } from 'react';
import { Button, FormControl, Select, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { deviceType } from '../constant/deviceType';
import { DEVICE_STATUS_FILTER, PAGE_SIZE_LIST } from '../constant/config';
import { useNavigate } from 'react-router';
import { _convertObjectToQuery } from '../utils/apiService';
import { useQuery } from '../hooks/useQuery';

const FilterBox = ({ listAgencies, searchRef, isAdmin }) => {
  const navigate = useNavigate();
  const queryParams = useQuery();

  const defaultFiltersValue = {
    agency_id: queryParams.agencyId || undefined,
    device_type_id: queryParams.deviceTypeId || undefined,
    status: queryParams.status || undefined
  };

  const [query, setQuery] = useState(defaultFiltersValue);

  const handleChange = (e, value, type) => {
    if (type === 'agency_type') {
      const queryValue = Object.assign({}, query, {
        agency_id: Number(value.id)
      });
      setQuery(queryValue);
    }
    if (type === 'device_type') {
      const queryValue = Object.assign({}, query, {
        device_type_id: Number(value.id)
      });
      setQuery(queryValue);
    }
    if (type === 'status_type') {
      const queryValue = Object.assign({}, query, {
        status: value.value
      });
      setQuery(queryValue);
    }
  };

  const handleFilter = () => {
    if (query) {
      const queryString = _convertObjectToQuery(query);
      navigate(`/app/manage/devices?${queryString}`);
      searchRef(query);
    }
  };

  const handleResetFilter = () => {
    setQuery({ agency_id: undefined, device_type_id: undefined, status: undefined });
    navigate('/app/manage/devices');
    searchRef({
      agency_id: undefined,
      device_type_id: undefined,
      status: undefined,
      page: 1,
      page_size: PAGE_SIZE_LIST
    });
  };

  return (
    <div className="py-3 px-4">
      <div className="row text-left title-filter mb-3">Bộ lọc</div>
      {isAdmin && (
        <div className="row justify-content-center mb-2">
          <FormControl className="filter-item" size="small" variant="outlined">
            <span className="mb-1 label-input-filter"> Đại lý </span>
            <Autocomplete
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              size="small"
              options={listAgencies || []}
              getOptionLabel={option => option.name}
              value={
                (listAgencies || []).find(
                  option => option.id === query.agency_id
                ) || null
              }
              onChange={(e, value) => handleChange(e, value, 'agency_type')}
              disableClearable
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Chọn đại lý"
                  name="agency_id"
                  InputProps={{
                    ...params.InputProps,
                    readOnly: true,
                    style: {
                      fontSize: '15px',
                      padding: '0 8px',
                      height: '40px'
                    }
                  }}
                />
              )}
            />
          </FormControl>
        </div>
      )}
      <div className="row justify-content-center mb-2">
        <FormControl className="filter-item" size="small" variant="outlined">
          <span className="mb-1 label-input-filter"> Mã thiết bị </span>
          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={deviceType || []}
            getOptionLabel={option => option.name}
            value={
              (deviceType || []).find(
                option => option.id === query.device_type_id
              ) || null
            }
            onChange={(e, value) => handleChange(e, value, 'device_type')}
            disableClearable
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Chọn mã thiết bị"
                name="device_type_id"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true,
                  style: {
                    fontSize: '15px',
                    padding: '0 8px',
                    height: '40px'
                  }
                }}
              />
            )}
          />
        </FormControl>
      </div>

      <div className="row justify-content-center mb-2">
        <FormControl className="filter-item" size="small" variant="outlined">
          <span className="mb-1 label-input-filter"> Trạng thái </span>
          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={DEVICE_STATUS_FILTER || []}
            getOptionLabel={option => option.name}
            value={
              (DEVICE_STATUS_FILTER || []).find(
                option => option.value === query.status
              ) || null
            }
            onChange={(e, value) => handleChange(e, value, 'status_type')}
            disableClearable
            fullWidth = {true}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Chọn trạng thái"
                name="device_type_id"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true,
                  style: {
                    fontSize: '15px',
                    padding: '0 8px',
                    height: '40px'
                  }
                }}
              />
            )}
          />
        </FormControl>
      </div>
      <div className="row mt-4">
        <div className="col-6">
          <Button
            className="btn-filter btn-plain"
            variant="contained"
            onClick={handleResetFilter}
          >
            Đặt lại
          </Button>
        </div>

        <div className="col-6">
          <Button
            className="btn-filter"
            color="primary"
            variant="contained"
            onClick={handleFilter}
          >
            Áp dụng
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBox;
